import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import ErrorViewer from "../ErrorViewer";
import React, {useEffect} from "react";
import {getLGA, getStates} from "../../redux/utils/utilsSlice";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {FaArrowLeft} from "react-icons/fa";

interface PropsI {
    nextPage: (values: any) => void;
    prevPage: () => void;
}

const LocationInformation = ({ nextPage, prevPage }: PropsI)=>{
    const dispatch = useAppDispatch();
    const { allStates, lgas } = useAppSelector((state) => state?.utils);


    const validationSchema = Yup.object().shape({
        house_Plot_No: Yup.string().required("Field is required"),
        streetName: Yup.string().required("Street name is required"),
        city: Yup.string().required("City is required"),
        state: Yup.string().required("Field is required"),
        localGovernmentID: Yup.string().required("Field is required"),
    });

    const { handleSubmit, register, setValue, formState: { errors },} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            house_Plot_No: "",
            streetName: "",
            city: "",
            state: "",
            localGovernmentID: "",
        }
    });

    const isFormValid = errors.house_Plot_No || errors.streetName || errors.city || errors.state || errors.localGovernmentID;

    const onSubmit = (values: any) =>{
        nextPage(values)
    }


    useEffect(()=>{
        dispatch(getStates());
    }, [])

    const onStateCodeChanged = (stateCode: string)=>{
        dispatch(getLGA({ stateCode }))
    }


    return (
        <div>
            <button className="btn btn-outline mb-4" onClick={prevPage}>
                <FaArrowLeft className="mr-2"/>
                Back
            </button>
            <div className="input_container">
                <label className="input_title" htmlFor="house-plot-number">
                    House Plot Number
                </label>
                <input
                    id="house-plot-number"
                    className="input_field"
                    type="text"
                    placeholder={"House Plot Number"}
                    {...register("house_Plot_No")}
                />
                {errors.house_Plot_No && (
                    <ErrorViewer message={errors.house_Plot_No.message as string}/>
                )}
            </div>
            <div className="input_container">
                <label className="input_title" htmlFor="street-name">
                    Street Name
                </label>
                <input
                    id="street-name"
                    className="input_field"
                    type="text"
                    placeholder={"Street Name"}
                    {...register("streetName")}
                />
                {errors.streetName && (
                    <ErrorViewer message={errors.streetName.message as string}/>
                )}
            </div>
            <div className="form__group">
                <label htmlFor="state">
                    State
                </label>
                <select id="state" defaultValue=""
                        className="form__select"
                        onChange={(e) => {
                            onStateCodeChanged(e.target.value);
                            setValue('state', e.target.value);
                            setValue('localGovernmentID', '');
                        }}
                >
                    <option value="" disabled>Select State</option>
                    {allStates && Object.keys(allStates).map((a) => (
                        <option value={a} key={a}>{allStates[a]}</option>
                    ))}
                </select>
                {errors.state && (
                    <ErrorViewer message={errors.state.message as string}/>
                )}
            </div>
            <div className="form__group">
                <label htmlFor="lga">
                    LGA
                </label>
                <select id="state" defaultValue=""
                        className="form__select"
                        {...register('localGovernmentID')}
                >
                    <option value="" disabled>Select LGA</option>
                    {lgas && Object.keys(lgas).map((lgaKey) => (
                        <option value={lgaKey} key={lgaKey}>{lgas[lgaKey]}</option>
                    ))}
                </select>
                {errors.localGovernmentID && (
                    <ErrorViewer message={errors.localGovernmentID.message as string}/>
                )}
            </div>

            <div className="input_container">
                <label className="input_title" htmlFor="street-name">
                    City
                </label>
                <input
                    id="street-name"
                    className="input_field"
                    type="text"
                    placeholder={"City"}
                    {...register("city")}
                />
                {errors.city && (
                    <ErrorViewer message={errors.city.message as string}/>
                )}
            </div>

            <button
                type="submit"
                className="btn btn-primary btn-primary-full"
                style={{backgroundColor: "#305F32"}}
                disabled={!!isFormValid}
                onClick={handleSubmit(onSubmit)}
            >
                Continue
            </button>
        </div>
    );
}

export default LocationInformation;